<template>
    <div id="App">
        <BaseHeader/>
        <BaseNav/>
        <router-view></router-view>
        <BaseFooter/>

        <!--登录dialog-->
        <LoginPop/>
    </div>
</template>

<script>
    import {mapState, mapActions} from 'vuex'
    import BaseHeader from "@/components/BaseHeader/BaseHeader";
    import LoginPop from "@/views/login/login";
    import BaseNav from "@/components/BaseNav/BaseNav";
    import BaseFooter from "@/components/BaseFooter/BaseFooter";
    import {getSwnavigationBar, getUserInfo} from '@/http/request'

    export default {
        name: 'App',
        components: {BaseHeader, BaseNav, BaseFooter, LoginPop},
        provide: {
            language: location.href.search('/en') > 0 ? 'en' : 'zh'
        },
        computed: {
            ...mapState(['token'])
        },
        created() {
            this.getSwnavigationBar();
            this.getUserInfo();
        },
        methods: {
            ...mapActions(["setUserInfo", 'setLoginStatus', 'setShowLoginPop']),


            // 获取个人信息
            getUserInfo() {
                if (this.token) {
                    getUserInfo().then(({data}) => {
                        if (data.code === 0) {
                            this.setUserInfo(data.data);
                            this.setLoginStatus(true);
                            this.setShowLoginPop(false);
                        } else {
                            this.$message({
                                type: 'error',
                                message: data.msg
                            })
                        }
                    })
                }
            },

            getSwnavigationBar() {
                getSwnavigationBar({limit: 100, targetType: 0}).then(({data}) => {
                    if (data.code === 0) {
                        this.handleResolveData(data.data.list);
                    }
                })
            },

            handleResolveData(data) {
                let arr = [];
                data.map((first) => {
                    if (first.parent == 0) {
                        arr.push(first);
                    }
                });
                arr.map((obj1, index) => {
                    obj1.index = index + 1;
                    data.map((obj2) => {
                        if (obj1.id === obj2.parent) {
                            if (obj1.children) {
                                obj1.children.push(obj2);
                            } else {
                                obj1.children = [obj2];
                            }
                        }
                    });
                });
                // this.dataList = arr;
                this.$store.dispatch('setNav', arr)
            }
        }
    }
</script>
<style lang="less" scoped>
    #App {
        min-height: 100vh;
        padding-bottom: 95px;
        box-sizing: border-box;
        position: relative;
    }
</style>
